import React, { useCallback } from 'react';
import { useParams, useHistory, Redirect } from 'react-router-dom';

import Box from '@mui/material/Box';

import { useAssignment } from '../../hooks';
import AssignmentDetailsHeader from '../../components/AssignmentDetailsHeader';

import { useAssignmentTabPages } from '../AssignmentPageTabs';

const AssignmentDetailsPage = () => {
  const history = useHistory();
  const { courseId, assignmentId } = useParams();
  const { assignment, loading } = useAssignment({ courseId, assignmentId });

  const { tabs, activePage, onGoToTab } = useAssignmentTabPages({
    assignment,
    loading,
  });
  const { Component, props: componentProps = {}, tab } = activePage || {};

  const handleEditAssignment = useCallback(() => {
    history.push(`/${courseId}/assignments/${assignmentId}/edit?from=details/${tab.slug}`);
  }, [history, assignmentId, courseId, tab]);

  return (
    <>
      <AssignmentDetailsHeader
        assignment={assignment}
        loading={loading}
        tabs={tabs}
        activeTab={tab}
        onGoToTab={onGoToTab}
        onEditAssignment={handleEditAssignment}
      />
      <Box mt={2}>{Component && <Component {...componentProps} />}</Box>
      {!activePage && <Redirect to="assignments" />}
    </>
  );
};

export default AssignmentDetailsPage;
